import { type ChartQueryParams } from '../../../hooks';
import { useMajorsChartQuery } from './useMajorsQuery';

export const useMajorsChart = (params?: ChartQueryParams) => {
	const { data, isLoading, error } = useMajorsChartQuery(params);

	return {
		nivoData: data?.data || null,
		isLoading,
		error,
	};
};
